import { Mandates } from "../../../shared/components/mandates/mandates";
import { UserTypes } from "../../../shared/constants";

export function BackOfficeMandates() {
  return <Mandates userType={UserTypes.Backoffice} />;
}
